import React from 'react'
import { styled } from '@material-ui/core/styles'
import FacebookIcon from '@material-ui/icons/Facebook'
import LinkedInIcon from '@material-ui/icons/LinkedIn'

import { ReactComponent as FooterLogoSvg } from 'img/Icon-square-no-background.svg'

import { IconButton, Grid, Typography } from '@material-ui/core'

import { Link, Svg, Section } from 'components'

const Root = styled('footer')({
  minHeight: '100px',
  backgroundColor: 'black',
  color: 'white',
})

const FooterLogo = styled(Svg)({
  height: '100%',
  maxHeight: '48px',
  width: 'auto',
})

const StyledLink = styled(Link)(({ theme }) => ({
  color: 'white',
  fontWeight: 'normal',
  display: 'block',
  margin: `${theme.spacing(1)}px 0`,
}))

const SocialButton = styled(IconButton)({
  color: 'white',
})

const Footer = () => (
  <Root>
    <Section py={5}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <FooterLogo svg={FooterLogoSvg} alt=" " />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography gutterBottom> </Typography>
          <StyledLink to="aboutUs">Over  </StyledLink>
          <StyledLink to="termsAndConditions">Algemene voorwaarden</StyledLink>
          <StyledLink to="privacyDeclaration">Privacyverklaring</StyledLink>
          <StyledLink to="cookieDeclaration">Cookies</StyledLink>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography gutterBottom>Bedrijfsgegevens</Typography>
          <Typography variant="body2">  B.V.</Typography>
          <Typography variant="body2">Torenallee 429</Typography>
          <Typography variant="body2">5617 BS Eindhoven</Typography>
          <Typography variant="body2">KvK 76060667</Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Typography gutterBottom>Contact</Typography>
          <StyledLink href="mailto:info@ .nl">info@ .nl</StyledLink>

          <SocialButton
            aria-label="Facebook"
            href="https://www.facebook.com/ .nl"
          >
            <FacebookIcon />
          </SocialButton>
          <SocialButton
            aria-label="LinkedIn"
            href="https://www.linkedin.com/company/14868597/"
          >
            <LinkedInIcon />
          </SocialButton>
          {/*
    <SocialButton
      aria-label="Instagram"
      href="https://www.instagram.com/ .nl/"
    >
      <InstagramIcon />
    </SocialButton>
    <SocialButton
      aria-label="Twitter"
      href="https://twitter.com/ NL"
    >
      <TwitterIcon/>
    </SocialButton>
    */}
        </Grid>
      </Grid>
    </Section>
  </Root>
)

export default Footer
